import { type InvitationCheckResponse } from "@vega-api/generated/types/invitationCheckResponse";
import { type InvitationCompleteResponse } from "@vega-api/generated/types/invitationCompleteResponse";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { getActivationFlowConfig } from "@vega-modules/scenes/ActivationNextStep/activationFlowConfig";
import { ActivationSuccessScreen } from "@vega-modules/scenes/ActivationNextStep/components/ActivationSuccessScreen";

export const SuccessMessage = ({
  invitationCheckData,
  invitationCompleteData,
}: {
  invitationCheckData?: InvitationCheckResponse;
  invitationCompleteData?: InvitationCompleteResponse;
}) => {
  const {
    global: { companyName },
  } = usePublicConfig();

  const flowConfig = getActivationFlowConfig(
    invitationCompleteData?.userActivationType,
    {
      companyName,
      invitationCheckData,
      redirectUrl: invitationCompleteData?.signupUrl,
    },
  );

  return <ActivationSuccessScreen config={flowConfig} />;
};
